module.exports = __webpack_public_path__ + "img/2025big18.73aecedc.jpg";